export type TicketStageId =
  | 'New'
  | 'Triaged'
  | 'InProgress'
  | 'PendingCustomer'
  | 'Resolved'
  | 'Closed'
  | 'Reopened';

export type TicketStageConfig = {
  id: TicketStageId;
  label: string;
  columnClass: string;
  headerClass: string;
  cardAccentClass: string;
};

export const ARCHIVED_TICKET_STATUSES: TicketStageId[] = ['Resolved', 'Closed'];

export const TICKET_STAGES: TicketStageConfig[] = [
  {
    id: 'New',
    label: 'Novo',
    columnClass: 'border-sky-200 bg-sky-50/40',
    headerClass: 'bg-sky-600 text-white',
    cardAccentClass: 'border-sky-500',
  },
  {
    id: 'Triaged',
    label: 'Triado',
    columnClass: 'border-indigo-200 bg-indigo-50/40',
    headerClass: 'bg-indigo-600 text-white',
    cardAccentClass: 'border-indigo-500',
  },
  {
    id: 'InProgress',
    label: 'Em atendimento',
    columnClass: 'border-amber-200 bg-amber-50/40',
    headerClass: 'bg-amber-600 text-white',
    cardAccentClass: 'border-amber-500',
  },
  {
    id: 'PendingCustomer',
    label: 'Aguardando cliente',
    columnClass: 'border-violet-200 bg-violet-50/40',
    headerClass: 'bg-violet-600 text-white',
    cardAccentClass: 'border-violet-500',
  },
  {
    id: 'Reopened',
    label: 'Reaberto',
    columnClass: 'border-rose-200 bg-rose-50/40',
    headerClass: 'bg-rose-600 text-white',
    cardAccentClass: 'border-rose-500',
  },
  {
    id: 'Resolved',
    label: 'Resolvido',
    columnClass: 'border-emerald-200 bg-emerald-50/40',
    headerClass: 'bg-emerald-600 text-white',
    cardAccentClass: 'border-emerald-500',
  },
  {
    id: 'Closed',
    label: 'Fechado',
    columnClass: 'border-secondary-200 bg-secondary-50/40',
    headerClass: 'bg-secondary-600 text-white',
    cardAccentClass: 'border-secondary-500',
  },
];

export const OPERATIONAL_TICKET_STAGES = TICKET_STAGES.filter(
  (stage) => !ARCHIVED_TICKET_STATUSES.includes(stage.id),
);

export function getTicketStageConfig(stage: string): TicketStageConfig {
  return TICKET_STAGES.find((item) => item.id === stage) ?? TICKET_STAGES[0];
}
